import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {CarerRelationship} from "@shared/api/models/query/patient.model";

@Injectable({
    providedIn: 'root'
})
export class CarerRelationshipsService extends PaginatorService<CarerRelationship> {

    protected override get domainEntity() {
        return 'lists/carer-relationships';
    };
}
